<template>
    <detail-view
      v-if="dataLoaded"
      @save="save"
      :config="config">
    </detail-view>
</template>

<script>
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import saveChanges from '@/mixins/detailViews/saveChanges';
import DetailView from '../../../components/detail/Detail.vue';

export default {
  components: {
    DetailView,
  },
  mixins: [fetchDetail, saveChanges],

  data() {
    return {
      module: 'redirect',
      endpoint: 'redirect',
      responseData: {
        single: 'redirect',
        multiple: 'redirects',
      },
      config: {
        module: 'redirect',
        endpoint: 'redirect',
        data: {
          location_from: '/',
          location_to: '/',
          status: '',
          catch_all: false,
          comments: '',
        },
        columns: {
          left: {
            cards: [{
              title: 'General',
              fields: [
                {
                  name: 'location_from',
                  value: '/',
                  label: 'From',
                  type: 'text',
                  required: true,
                },
                {
                  name: 'location_to',
                  type: 'text',
                  value: '',
                  label: 'To',
                  required: true,
                },
                {
                  name: 'status',
                  type: 'select',
                  value: null,
                  label: 'Status',
                  options: [
                    {
                      value: 301,
                      label: '301',
                    },
                    {
                      value: 302,
                      label: '302',
                    },
                  ],
                  required: true,
                },
                {
                  name: 'catch_all',
                  label: 'Catch all',
                  value: false,
                  color: 'secondary',
                  type: 'toggle',
                },
              ],
            }],
          },
          right: {
            cards: [{
              title: 'Comments',
              fields: [
                {
                  name: 'comments',
                  type: 'textarea',
                  label: 'Comments',
                  required: false,
                },
              ],
            }],
          },
        },
      },
    };
  },
  methods: {
    save(data) {
      this.config.data = data;
      this.saveChanges();
    },

    requestParams() {
      return {
        location_from: this.config.data.location_from,
        location_to: this.config.data.location_to,
        status: this.config.data.status,
        catch_all: this.config.data.catch_all ? '1' : '0',
        comments: this.config.data.comments,
      };
    },
  },
};
</script>
